import { DocumentUserPermission } from '@quadminds/client-apis/agents';
import { useQuery } from '@tanstack/react-query';
import { DocumentRoles } from '../interfaces/document/document.input';
import { agentsApi } from '../services/agents-api.service';

const useGePermissions = (isEnabled: boolean, documentId?: string) => {
    const getAllPermissionsQuery = useQuery<DocumentRoles[]>({
        queryKey: ['permissions'],
        queryFn: async () => agentsApi.getAllPermissions(),
        staleTime: 1000 * 60 * 60 * 24,
    });

    const getPermissionsPerDocument = useQuery<DocumentUserPermission[]>({
        queryKey: ['document-permissions', documentId],
        queryFn: async () => {
            if (!documentId) return [];
            return agentsApi.getUsersPerDocument(documentId);
        },
        enabled: !!documentId && isEnabled,
    });

    return {
        getAllPermissionsQuery,
        getPermissionsPerDocument,
    };
};

export default useGePermissions;
